module.exports = __webpack_public_path__ + "img/DJI_0025.a959ad1b.jpg";